import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-carbon-warning-modal',
  templateUrl: './carbon-warning-modal.component.html',
  styleUrls: ['./carbon-warning-modal.component.scss'],
})
export class CarbonWarningModalComponent {
  @Input() active: boolean = false;
  @Input() title: string = 'Atenção';
  @Input() message: string = '';
  @Input() confirmText: string = 'Sim, confirmar';
  @Input() cancelText: string = 'Não, cancelar';
  @Input() middleText: string = ''; // Novo: texto do botão do meio
  @Input() customContent: boolean = false; // Novo: permite conteúdo customizado via ng-content
  /** Quando true, permite dropdown (ex.: ng-select) vazar do modal sem ser cortado. */
  @Input() contentOverflowVisible = false;
  @Input() disableClose: boolean = false; // Novo: desabilita o X e o clique fora
  @Input() loading: boolean = false; // Novo: desabilita botões e não fecha automaticamente durante loading
  @Input() disableConfirm: boolean = false; // Novo: desabilita o botão de confirmar (ex: formulário inválido)
  @Input() confirmAction: () => void = () => {};
  @Input() cancelAction: () => void = () => {};
  @Input() middleAction: () => void = () => {}; // Novo: ação do botão do meio

  @Output() onClose = new EventEmitter<void>();

  constructor(private sanitizer: DomSanitizer) {}

  get safeMessage(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

  // Novo: verifica se tem botão do meio
  get hasMiddleButton(): boolean {
    return !!this.middleText && this.middleText.trim() !== '';
  }

  // Verifica se tem botão cancel
  get hasCancelButton(): boolean {
    return !!this.cancelText && this.cancelText.trim() !== '';
  }

  closeModal() {
    this.onClose.emit();
  }

  onConfirm() {
    if (this.loading) return; // Não faz nada se estiver em loading
    this.confirmAction();
    // Aguarda um ciclo de detecção de mudanças para verificar se loading foi ativado
    setTimeout(() => {
      if (!this.loading) {
        this.closeModal();
      }
    }, 0);
  }

  onCancel() {
    if (this.loading) return; // Não faz nada se estiver em loading
    this.cancelAction();
    // Aguarda um ciclo de detecção de mudanças para verificar se loading foi ativado
    setTimeout(() => {
      if (!this.loading) {
        this.closeModal();
      }
    }, 0);
  }

  // Novo: ação do botão do meio
  onMiddle() {
    if (this.loading) return; // Não faz nada se estiver em loading
    this.middleAction();
    // Aguarda um ciclo de detecção de mudanças para verificar se loading foi ativado
    setTimeout(() => {
      if (!this.loading) {
        this.closeModal();
      }
    }, 0);
  }
}
